$(window).ready(function($) {
    $(".announcement-bar").owlCarousel({
        dots: true,
        center: true,
        autoplay:true,
        autoplayTimeout:5000,
        loop:true,
        items: 1,
        lazyLoad:true
    });
    $(document).on("click", ".product-form-sticky__submit", function(){
        $("#product-form__buttons .product-form__submit").trigger("click");
    });
  
    $(document).on("click", ".product-recommendations--loaded .product-form__submit", function(){
      setTimeout(function(){
            toggleCartDrawer();
        }, 500);
    });
});